/**
 * How often something pays, as one character.
 *
 * The same vocabulary serves a fund's stated schedule and an individual
 * payment's kind, because they describe the same thing — and when they were
 * separate types they drifted: a semi-monthly payment was recorded as monthly
 * by one parser and as nothing by the other.
 */
export type Frequency = 'weekly' | 'biweekly' | 'monthly' | 'semimonthly' | 'quarterly' | 'semiannual' | 'annual';

export const FREQUENCIES: Record<string, { name: Frequency; label: string; perYear: number }> = {
    w: { name: 'weekly', label: 'Weekly', perYear: 52 },
    b: { name: 'biweekly', label: 'Bi-Weekly', perYear: 26 },
    s: { name: 'semimonthly', label: 'Semi-Monthly', perYear: 24 },
    m: { name: 'monthly', label: 'Monthly', perYear: 12 },
    q: { name: 'quarterly', label: 'Quarterly', perYear: 4 },
    h: { name: 'semiannual', label: 'Semi-Annual', perYear: 2 },
    y: { name: 'annual', label: 'Annual', perYear: 1 },
};

const BY_NAME: Record<string, string> = Object.fromEntries(Object.entries(FREQUENCIES).map(([code, meta]) => [meta.name, code]));

export const frequencyOf = (code: string | null | undefined): Frequency | null => (code ? (FREQUENCIES[code]?.name ?? null) : null);
export const codeForFrequency = (name: string | null | undefined): string | null => (name ? (BY_NAME[name] ?? null) : null);
/** Payments a year, for annualising a rate. */
export const perYear = (code: string | null | undefined): number | null => (code ? (FREQUENCIES[code]?.perYear ?? null) : null);
